import React, {useState} from 'react'
import {Row,Col,Button,Modal} from 'react-bootstrap'
import { SendOrderMail, Capitalize } from './utility/BillCalculator';

export default function MainInfo(props) {


  function ValidateEmail()
  {
    let mailformat = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    let email = document.forms["mailsend"].elements[0].value;
    if(email.match(mailformat))
    {
      //alert("You have entered a valid email address!");    
      SendOrderMail( props.billconfig, email, setShowMail );
      return true;
    }
    else
    {
      alert("You have entered an invalid email address!");   
      document.forms["mailsend"].elements[0].focus();
      return false;
    }

  }

  const [showList, setShowList] = useState(false);
  const [showMail, setShowMail] = useState(false);

  const billList = Object.keys(props.billconfig).map( sectName=>{
    const sect = props.billconfig[sectName];
    const billListRecords = Object.keys(sect).map(subsectName=>{
      const subsect = props.billconfig[sectName][subsectName];
      return(
        <Row className='border-bottom border-secondary'>
          <Col className='col-meta'>{subsect.leggera_code?subsect.leggera_code:""}</Col>
          <Col className='col-2'>{Capitalize(sectName)}</Col>
          <Col className='col-2'>{Capitalize(subsectName)}</Col>
          <Col className='col-6'>{subsect.supplier_descr}</Col>
          <Col className='col-meta'>{subsect.um}</Col>
          <Col className='col-1' style={{ textAlign: "right"}}>{subsect.qty}</Col>
        </Row>
      )
    })

    return billListRecords;
  })


  return(
    <>
        <Row className='text-white p-2 display-10 border-bottom border-secondary'>
          <Col className='col-3 align-right'>
           Model:
          </Col>
          <Col className='col-4 text-leggera-red'>
            {props.config.lift.model.modelname}
          </Col>
        </Row>
        <Row className='text-white display-10 p-2 border-bottom border-secondary'>
          <Col className='col-3 align-right'>
             Platform dimension:
          </Col>
          <Col className='col-4 text-leggera-red'>
            {props.config.lift.model.dimensions.width} <span className='text-secondary'>x</span> {props.config.lift.model.dimensions.depth} <span className='text-secondary'>cm</span>
          </Col>
        </Row>
        <Row className='text-white display-10 p-2 '>
          <Col className='col-3 align-right'>
           Structure:
          </Col>
        </Row>
        <Row className='text-white display-10 p-2'>
          <Col className='col-3'/>
          <Col className='col-2 align-right'>
           Size:
          </Col>
          <Col className='col-4 text-leggera-red'>
            {props.config.lift.structure.size} <span className='text-secondary'>cm</span>
          </Col>
        </Row>
        <Row className='text-white p-2 display-10 border-bottom border-secondary'>
          <Col className='col-3'/>
          <Col className='col-2 align-right'>
           Color:
          </Col>
          <Col className='col-4 text-leggera-red'>
            {props.config.lift.structure.texture} 
          </Col>
        </Row>
        <Row className='text-white p-2 display-10  border-bottom border-secondary'>
          <Col className='col-3 align-right'>
           Floor Count:
          </Col>
          <Col className='col-4 text-leggera-red'>
            {props.config.lift.floors.length} 
          </Col>
        </Row>
        <Row className='text-white display-10 p-2 '>
          <Col className='col-3 align-right'>
           Cabin:
          </Col>
        </Row>

        <Row className='text-white display-10 p-2'>
          <Col className='col-3'/>
          <Col className='col-2 align-right'>
           Monitor
          </Col>
          <Col className='col-6 text-leggera-red'>
            {props.config.cabin.monitor?'YES':'NO'}
          </Col>
        </Row>

        <Row className='text-white display-10 p-2'>
          <Col className='col-3'/>
          <Col className='col-2 align-right'>
           Top Panel
          </Col>
          <Col className='col-6 text-leggera-red'>
            {props.config.cabin.backTop.texture} <span className='text-secondary'>[</span>{props.config.cabin.backTop.material}<span className='text-secondary'>]</span>
          </Col>
        </Row>

        <Row className='text-white display-10 p-2'>
          <Col className='col-3'/>
          <Col className='col-2 align-right'>
           Bottom Panel
          </Col>
          <Col className='col-6 text-leggera-red'>
            {props.config.cabin.backBottom.texture} <span className='text-secondary'>[</span>{props.config.cabin.backBottom.material}<span className='text-secondary'>]</span>
          </Col>
        </Row>

        <Row className='text-white p-2 display-10 border-bottom border-secondary'>
          <Col className='col-3'/>
          <Col className='col-2 align-right'>
           Carpet
          </Col>
          <Col className='col-6 text-leggera-red'>
            {props.config.cabin.carpet.texture} <span className='text-secondary'>[</span>{props.config.cabin.carpet.material}<span className='text-secondary'>]</span>
          </Col>
        </Row>

        <Row className='text-white p-2 display-10 border-bottom border-secondary'>
          <Col className='col-3 align-right'>
           <Button onClick={e=>setShowMail(!showList)}>Send Mail to receive information</Button>
          </Col>
        </Row>

        <Row className='text-white p-2 display-10 border-bottom border-secondary'>
          <Col className='col-3 align-right'>
           <Button onClick={e=>setShowList(!showList)}>Show Material List (only for testing purpose)</Button>
          </Col>
        </Row>

        <Modal size='xl' show={showList} onHide={e=>setShowList(false)} >
          <Modal.Header closeButton on>
              <Modal.Title>Materials List</Modal.Title>
          </Modal.Header>
          
          <Modal.Body className=''>
            {billList}
          </Modal.Body>
        
          
          <Modal.Footer>
              <Button variant="primary" onClick={e=>setShowList(false)}>&nbsp;&nbsp;OK&nbsp;&nbsp;</Button>
          </Modal.Footer>
      </Modal>

      <Modal size='lg' show={showMail} onHide={e=>setShowMail(false)} >
          <Modal.Header closeButton on>
              <Modal.Title>Information Request</Modal.Title>
          </Modal.Header>
          
          <Modal.Body className='modal-info'>
            <form id="mailsend">
              <label for="email">Your email:</label>
              <input type="email" id="email" name="email" placeholder="mailaccount@yourdomain.org" style={{width: "20rem"}}/>
            </form>
          </Modal.Body>
        
          
          <Modal.Footer>
          <Button variant="primary" onClick={ValidateEmail}>Send</Button>
          <Button variant="secondary" onClick={e=>{setShowMail(false)}}>Cancel</Button>
          </Modal.Footer>
      </Modal>

    </>
  )
}
